import { FunctionComponent, useEffect, useState } from 'react';
import {
  Box,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

import useMobileDetect from '../../../../hooks/useMobileDetect';
import { useUser } from '../../../../state/user';
import { ProfileCompletionStepComponentBaseProps } from '../../../../types/ProfileCompletionStep';
import { SponsorshipApplicationBase } from '../../../../types/sponsorshipApplication';
import { SponsorshipApplicationStatus } from '../../../../types/sponsorshipApplicationStatuses';
import { CloseButton } from '../CloseButton';
import ProfilePopUpButtons from '../ProfilePopUpButtons';

type ProfileStartSignAgreementStepProps = ProfileCompletionStepComponentBaseProps;

const ProfileStartSignAgreementStep: FunctionComponent<
  ProfileStartSignAgreementStepProps
> = ({ title, navigateNext, sponsorshipApplication }) => {
  const isMobile = useMobileDetect();

  const [ approvedSponsorshipApplication, setApprovedSponsorshipApplication ]
    = useState<SponsorshipApplicationBase | null>(null);
  const user = useUser();

  useEffect(() => {
    if (user.contents && user.contents.sponsorshipApplications) {
      const approvedSponAppList = user.contents.sponsorshipApplications.filter(
        (sponApp: SponsorshipApplicationBase) =>
          sponApp.status === SponsorshipApplicationStatus.ACCEPTED,
      );

      if (approvedSponAppList.length) {
        setApprovedSponsorshipApplication(approvedSponAppList[0]);
      }
    }
  }, [user.contents]);

  if (!approvedSponsorshipApplication) return null;

  return (
    <Box id='application-submit-modal'>
      <CloseButton />
      <DialogTitle id='start-sign-agreement-title' sx={{ p: 0, mb: 2 }}>
        <Typography align='center' variant='h2'>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 0, mb: 4 }}>
        <DialogContentText id='start-sign-agreement-description'>
          <Typography align='center' variant='subtitle1'>
            {sponsorshipApplication?.partner_name || 'Your employer'} has approved your application. You just need to confirm a few details and sign your loan repayment agreement. Then it&apos;s official!
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <ProfilePopUpButtons
          onStandaloneClick={navigateNext}
          showContinue={false}
          showSaveAndExit={isMobile}
          standalone={true}
          standaloneText='Sign my agreement'
        />
      </DialogActions>
    </Box>
  );
};

export default ProfileStartSignAgreementStep;
